<template>
  <div>
    <va-modal
      :value="showModal"
      id="oneCareAppPasswordModal"
      ref="oneCareAppPasswordModal"
      size="medium"
      :hideDefaultActions="true"
      :fixedLayout="true">
      <div slot="header" class="modal-title d-flex justify--space-between pb-0 mb-0">
        <h5>{{$t('dashboard_new_evollu.patient_details.onecare_app_password.manage_password')}}</h5>
      </div>

      <div>
        <div class="row" style="margin-top: -20px; margin-bottom: 20px">
          <h6 class="is-bold" style="color: #5b5b5b">{{$t('agenda.appointments.pacient')}}: </h6>
          <h6 style="color: #5b5b5b">&ensp;{{patientDetails.name}}</h6>
        </div>

      </div>

      <div v-if="isLoading">
        <loading-placeholder />
      </div>

      <div v-else>
        <div v-if="patientDetails.email">
          <span>{{this.$t('dashboard_new_evollu.patient_details.onecare_app_password.send_by_email_txt', {email: patientDetails.email})}}</span>

          <div slot="actions" class="d-flex justify--space-between mt-4">
            <va-button @click.prevent="handleClose">{{$t('modal.close')}}</va-button>
            <va-button @click.prevent="sendPassword">{{$t('dashboard_new_evollu.patient_details.onecare_app_password.send_by_email_btn')}}</va-button>
          </div>
        </div>
        <div v-else>
          <span>{{$t('dashboard_new_evollu.patient_details.onecare_app_password.no_email_show_password')}}</span>
          <div class="row mt-0 mt-2" v-if="username">
            <span class="is-bold">Username: </span> <span>&ensp;{{username}}</span>
          </div>


          <div class="row col-3 evollu-form mt-4" >
            <div class="password-container">
              <input
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                readonly
                autocomplete="new-password"
                class="password-input"
              />
              <i
                class="fa"
                :class="showPassword ? 'fa-eye' : 'fa-eye-slash'"
                @mousedown="togglePassword(true)"
                @mouseup="togglePassword(false)"
                @mouseleave="togglePassword(false)"
              ></i>
            </div>
          </div>

          <div slot="actions" class="d-flex justify--center mt-4">
            <va-button @click.prevent="handleClose">{{$t('modal.close')}}</va-button>
          </div>
        </div>
      </div>




    </va-modal>

  </div>
</template>

<script>
import { OneCareService } from '@/api/OneCareService';
import LoadingPlaceholder from '@/components/common/LoadingPlaceholder.vue';

export default {
  components: { LoadingPlaceholder },
  props: {
    patientDetails: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isLoading: false,
      showModal: false,
      showPassword: false,
      password: '',
      username: null
    }
  },
  async mounted() {
    this.showModal = true

    if (!this.patientDetails.email) {
      this.isLoading = true
      try {
        const data = await OneCareService.getTempPassword(this.patientDetails.idPerson)
        this.password = data.tempPassword
        this.username = data.username
      } catch(e) {
        console.log(e)
        this.showToast(this.$t('leads.messages.error'), this.$store.state.errorToastOptions)
      } finally {
        this.isLoading = false
      }

    }

  },
  computed: {

  },
  methods: {
    generatePassword() {
      return Math.random().toString(36).slice(-8);
    },
    togglePassword(state) {
      this.showPassword = state;
    },
    sendPassword: async function() {
      this.isLoading = true
      try {
        await OneCareService.sendOneCareAppUserPassword(this.patientDetails.idPerson)
        this.handleClose()
      } catch (e) {
        console.log(e)
        this.showToast(this.$t('leads.messages.error'), this.$store.state.errorToastOptions)
        this.isLoading = false
      }
    },
    handleClose: function() {
      setTimeout(() => {
        this.$emit('close')
      }, 500 )
      this.showModal = false
    }
  }
}

</script>

<style lang="scss" scoped>
.password-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.password-input {
  width: 100%;
  padding-right: 40px;
  font-size: 16px;
  border-radius: 20px;
  padding: 8px;
  border: 1px solid #ccc;
  outline: none;
}

.password-container:hover .password-input {
  border-color: $evollu-dark;
  box-shadow: 0 0 5px $evollu-dark;
}

.fa {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  font-size: 18px;
  color: $evollu-dark;
}

.fa:hover {
  color: $evollu-light;
}
</style>
